/* ============================================================
   Naqaa (نقاء) — comportements du thème
   Chargé une fois depuis layout/theme.liquid :
   <script src="{{ 'naqaa.js' | asset_url }}" defer></script>
   ============================================================ */
(function () {
  function naqaaInitGalleries(root) {
    (root || document).querySelectorAll('[data-naqaa-gallery]').forEach(function (gallery) {
      var main = gallery.querySelector('[data-naqaa-gallery-main] img');
      var thumbs = gallery.querySelectorAll('[data-naqaa-gallery-thumb]');
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          thumbs.forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
          if (main) main.src = thumb.getAttribute('data-full');
        });
      });
    });
  }

  function boot() {
    naqaaInitGalleries();
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', function (event) {
    naqaaInitGalleries(event.target);
  });
})();
